import type { TFunction } from "i18next";
import type {
  PaidMediaOverviewPlatform,
  PaidMediaOverviewQuadrant,
} from "src/services/PaidMediaOverviewAPI";

const STATUS_I18N_KEY: Record<string, string> = {
  SCALE_WINNER: "paidMediaOverview.statuses.scaleWinner",
  EFFICIENCY_WINNER: "paidMediaOverview.statuses.efficiencyWinner",
  GROWTH_OPPORTUNITY: "paidMediaOverview.statuses.growthOpportunity",
  STABLE: "paidMediaOverview.statuses.stable",
  HIGH_SPEND_LOW_RETURN: "paidMediaOverview.statuses.highSpendLowReturn",
  NEEDS_REVIEW: "paidMediaOverview.statuses.needsReview",
  LOW_PRIORITY: "paidMediaOverview.statuses.lowPriority",
};

const STATUS_MODIFIER: Record<string, string> = {
  SCALE_WINNER: "scale-winner",
  EFFICIENCY_WINNER: "efficiency-winner",
  GROWTH_OPPORTUNITY: "growth-opportunity",
  STABLE: "stable",
  HIGH_SPEND_LOW_RETURN: "high-spend-low-return",
  NEEDS_REVIEW: "needs-review",
  LOW_PRIORITY: "low-priority",
};

const QUADRANT_REASON_KEY: Record<PaidMediaOverviewQuadrant | string, string> = {
  SCALE_WINNER: "paidMediaOverview.quadrant.reasonScaleWinner",
  GROWTH_OPPORTUNITY: "paidMediaOverview.quadrant.reasonGrowthOpportunity",
  HIGH_SPEND_LOW_RETURN: "paidMediaOverview.quadrant.reasonHighSpendLowReturn",
  LOW_PRIORITY: "paidMediaOverview.quadrant.reasonLowPriority",
};

export function normalizeOverviewStatusCode(code: string | null | undefined): string {
  if (!code) {
    return "";
  }
  return code
    .trim()
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toUpperCase();
}

export function overviewStatusModifier(code: string | null | undefined): string {
  return STATUS_MODIFIER[normalizeOverviewStatusCode(code)] || "unknown";
}

export function overviewStatusLabel(
  t: TFunction,
  code: string | null | undefined,
  backendLabel?: string | null
): string {
  const key = STATUS_I18N_KEY[normalizeOverviewStatusCode(code)];
  if (key) {
    return t(key);
  }
  return backendLabel?.trim() || code || "";
}

export function overviewQuadrantReason(
  t: TFunction,
  quadrant: PaidMediaOverviewQuadrant | string | null | undefined,
  name: string
): string {
  const key = QUADRANT_REASON_KEY[normalizeOverviewStatusCode(quadrant)];
  return key ? t(key, { name }) : "";
}

export function overviewPlatformLabel(
  t: TFunction,
  platform: PaidMediaOverviewPlatform | null | undefined
): string {
  if (platform === "meta_ads") {
    return t("paidMediaOverview.platforms.meta");
  }
  if (platform === "google_ads") {
    return t("paidMediaOverview.platforms.google");
  }
  return "";
}
